export const SUCCESS_CODES = new Set([
  200, 201, 202, 203, 204, 205, 206, 207, 208, 226,
]);
